<template>
  <div class="app">
    <Loading :value="loading"></Loading>

    <!-- RACOURCIS -->
    <v-card>
      <v-card-title>
        <v-breadcrumbs divider="/">
          <v-breadcrumbs-item
            icons router :to='item.path'
            v-for="item in racourcis" :key="item.text"
            :disabled="item.disabled"
          >
            {{ item.text }}
          </v-breadcrumbs-item>
        </v-breadcrumbs>
      </v-card-title>
    </v-card>
    <br>

    <!-- DASHBORD PARAMETRES -->
    <v-card>
      <v-toolbar style="flex: 0 0 auto;" dark class="blue">
        <v-toolbar-title>  </v-toolbar-title>
      </v-toolbar>

      <v-card-text>
        <el-row :gutter="20">
          <el-col :span="6">
            <div class="grid-content bg-purple">
              <el-card class="box-card" style="background:#fff">
                <div class="text item">
                  <el-button v-if="droitAcces.index_parametre" icons @click="param()" style="margin:5px; width:100%">Vue d'ensemble <v-icon right>aspect_ratio</v-icon></el-button>
                  <el-button v-if="droitAcces.admin_new_param_code" icons @click="paramCode()" style="margin:5px; width:100%">Code et identifiant <v-icon right>code</v-icon></el-button>
                  <el-button v-if="droitAcces.admin_new_param_alert" icons @click="paramAlert()" style="margin:5px; width:100%">Alert et notification <v-icon right>add_alert</v-icon></el-button>
                  <el-button v-if="droitAcces.index_service" icons @click="paramService()" style="margin:5px; width:100%">Service <v-icon right>pie_chart_outlined</v-icon></el-button>
                  <el-button  v-if="droitAcces.route_all_application" icons @click="paramRoute()" style="margin:5px; width:100%">Routes <v-icon right>rounded_corner</v-icon></el-button>
                  <!-- <el-button v-if="droitAcces.route_all_application" icons @click="paramRoute()" style="margin:5px; width:100%">Routes <v-icon right>rounded_corner</v-icon></el-button> -->
                </div>
              </el-card>
            </div>
          </el-col>

          <el-col :span="18" >
            <div class="grid-content bg-purple">
              <el-card class="box-card" style="background:#fff">
                <!-- AFFICHER LA INFORMATION -->
                <el-tabs v-if="droitAcces.index_parametre && etatParam">
                  <el-tab-pane>
                    <span slot="label"> Ma configuration <v-icon right>dashboard</v-icon></span>
                    <!-- VUE D'ENSEMBLE -->
                    <el-row :gutter="20">
                      <v-container fluid grid-list-md>
                        <el-card class="box-card">
                          <v-layout row>
                            <v-flex md4>
                              <v-avatar size="140px" class="grey lighten-4">
                                <img v-if="listParam.url" :src="listParam.url" class="lazy" alt="">
                                <img v-else :src="logoUser" class="lazy" alt="">
                              </v-avatar>
                            </v-flex>
                            <v-flex md4>
                              <p><b>Raison sociale : </b> {{listParam.nom}} </p>
                              <p><b>Forme juridique : </b> {{listParam.formeJuridique}} </p>
                              <p><b>Siège : </b> {{listParam.siege}}</p>
                              <p><b>Directeur général : </b> {{listParam.dg}} </p>
                              <p><b>Contact : </b> {{listParam.contact}}</p>
                              <p><b>Capital : </b> {{listParam.capital}} FCFA</p>
                            </v-flex>
                            <v-flex md4>
                              <p><b>Prestataire : </b> {{listParam.nomPrestataire}}</p>
                              <p><b>Validateur des demandes : </b> {{listParam.validateurDemande}}</p>
                              <p><b>Validateur des dévis : </b> {{listParam.validateurDevis}}</p>
                              <p><b>Responsable technique : </b> {{listParam.responsableTechnik}}</p>
                              <p><b>SMS SENDER : </b> {{listParam.sms}}</p>
                              <p><b>MAIL SENDER : </b> {{listParam.mail}}</p>
                            </v-flex>
                          </v-layout>
                          <p align="center">
                            <v-chip outline text-color="primary" label color="primary" style="font-size:20px; width:100%">
                              CONFIGURATION DES PREFIXES DES CODES
                            </v-chip>
                          </p>
                          <v-layout row>
                            <v-flex md4>
                              <p><b>Utilisateur : </b> {{listParam.user}} </p>
                              <p><b>Fournisseur : </b> {{listParam.fournisseur}} </p>
                              <p><b>Entrepot : </b> {{listParam.entrepot}}</p>
                              <p><b>Caisse : </b> {{listParam.caisse}} </p>
                              <p><b>Stock : </b> {{listParam.stock}} </p>
                              <p><b>Sortie d'entrepot : </b> {{listParam.sortir}} </p>
                              <p><b>Retour d'entrepot : </b> {{listParam.entree}}</p>
                              <p><b>Transfert : </b> {{listParam.transfert}} </p>
                              <p><b>Maintenance : </b> {{listParam.maintenance}} </p>
                            </v-flex>
                            <v-flex md4>
                              <p><b>Véhicule : </b> {{listParam.vehicule}} </p>
                              <p><b>Projet : </b> {{listParam.projet}}</p>
                              <p><b>Commande : </b> {{listParam.commande}}</p>
                              <p><b>Facture : </b> {{listParam.facture}} </p>
                              <p><b>Inventaire : </b> {{listParam.inventaire}} </p>
                              <p><b>Produit : </b> {{listParam.produit}} </p>
                              <p><b>Paiement caisse : </b> {{listParam.paiement}}</p>
                              <p><b>Livraison : </b> {{listParam.livraison}}</p>
                              <p><b>Approvisionnment : </b> {{listParam.appro}}</p>
                            </v-flex>
                            <v-flex md4>
                              <p><b>Créditer la caisse : </b> {{listParam.approCaisse}}</p>
                              <p><b>Demande d'intervention : </b> {{listParam.intervention}}</p>
                              <p><b>Client : </b> {{listParam.client}}</p>
                              <p><b>Contrat de location : </b> {{listParam.location}}</p>
                              <p><b>Vignette : </b> {{listParam.vignette}}</p>
                              <p><b>Visite technique : </b> {{listParam.visite}}</p>
                              <p><b>Assurance : </b> {{listParam.assurance}}</p>
                              <p><b>Mission : </b> {{listParam.mission}}</p>
                            </v-flex>
                          </v-layout>
                        </el-card>
                      </v-container>
                    </el-row>
                  </el-tab-pane>
                </el-tabs>

                <!-- VUE D'ENSEMBLE -->
                <el-tabs v-if="droitAcces.admin_new_param && etatGlobal">
                  <el-tab-pane>
                    <span slot="label"> Vue d'ensemble <v-icon right>aspect_ratio</v-icon></span>

                    <el-row>
                      <v-container fluid grid-list-md>
                        <el-card class="box-card">
                          <v-form v-model="valid" ref="formGlobal" lazy-validation id="formGlobal">
                            <v-layout row>
                              <v-flex md4>
                                <div class="block">
                                  <span class="demonstration">Raison sociale</span>
                                  <el-input name="nom" placeholder="Raison sociale" v-model="paramGlobal.nom"></el-input>
                                </div>
                              </v-flex>
                              <v-flex md4>
                                <div class="block">
                                  <span class="demonstration">Forme jurique</span>
                                  <el-input name="formeJuridique" placeholder="Forme jurique" v-model="paramGlobal.formeJuridique"></el-input>
                                </div>
                              </v-flex>
                              <v-flex md4>
                                <div class="block">
                                  <span class="demonstration">Siège social</span>
                                  <el-input name="siege" placeholder="Siège social" v-model="paramGlobal.siege"></el-input>
                                </div>
                              </v-flex>
                            </v-layout>

                            <v-layout row>
                              <v-flex md4>
                                <div class="block">
                                  <span class="demonstration">Contact</span>
                                  <el-input name="contact" placeholder="Contact" v-model="paramGlobal.contact"></el-input>
                                </div>
                              </v-flex>
                              <v-flex md4>
                                <div class="block">
                                  <span class="demonstration">Capital</span>
                                  <el-input name="capital" placeholder="Capital" v-model="paramGlobal.capital"></el-input>
                                </div>
                              </v-flex>

                               <v-flex md4>
                                <div class="block">
                                  <span class="demonstration">Directeur Général</span>
                                  <el-select filterable v-model="paramGlobal.idDirecteur" placeholder="Directeur Général" style="width:100%">
                                    <el-option v-for="item in users" :key="item.id" :label="item.nom" :value="item.id">
                                    </el-option>
                                  </el-select>
                                </div>
                              </v-flex>


                              <v-flex md4>
                                <div class="block">
                                  <span class="demonstration">Nom et prénoms du DG</span>
                                  <el-input name="dg" placeholder="Nom et prénoms du DG" v-model="paramGlobal.dg"></el-input>
                                </div>
                              </v-flex>
                            </v-layout>

                            <v-layout row>
                              <v-flex md4>
                                <div class="block">
                                  <span class="demonstration">Prestataire</span>
                                  <el-select filterable v-model="paramGlobal.idPres" placeholder="Prestataire" style="width:100%">
                                    <el-option v-for="item in listPrestataire" :key="item.idPres" :label="item.libelle" :value="item.idPres">
                                    </el-option>
                                  </el-select>
                                </div>
                              </v-flex>
                              <v-flex md4>
                                <div class="block">
                                  <span class="demonstration">Validateur des demandes</span>
                                  <el-select filterable v-model="paramGlobal.idValidateurDemande" placeholder="Validateur des demandes" style="width:100%">
                                    <el-option v-for="item in users" :key="item.id" :label="item.nom" :value="item.id">
                                    </el-option>
                                  </el-select>
                                </div>
                              </v-flex>
                              <v-flex md4>
                                <div class="block">
                                  <span class="demonstration">Validateur des dévis</span>
                                  <el-select filterable v-model="paramGlobal.idValidateurDevis" placeholder="Validateur des dévis" style="width:100%">
                                    <el-option v-for="item in users" :key="item.id" :label="item.nom" :value="item.id">
                                    </el-option>
                                  </el-select>
                                </div>
                              </v-flex>
                            </v-layout>

                            <v-layout row>
                              <v-flex md4>
                                <div class="block">
                                  <span class="demonstration">Montant alert seuil validation</span>
                                  <el-input type="number" min="0" name="montantSeuil" placeholder="Montant alert seuil validation" v-model="paramGlobal.montantSeuil"></el-input>
                                </div>
                              </v-flex>
                              <v-flex md4>
                                <div class="block">
                                  <span class="demonstration">SMS</span>
                                  <el-input min="0" name="sms" placeholder="SMS SENDER" v-model="paramGlobal.sms"></el-input>
                                </div>
                              </v-flex>
                              <v-flex md4>
                                <div class="block">
                                  <span class="demonstration">Mail</span>
                                  <el-input min="0" name="mail" placeholder="MAIL SENDER" v-model="paramGlobal.mail"></el-input>
                                </div>
                              </v-flex>
                            </v-layout>

                            <v-layout row >
                              <v-flex md4>
                                <div class="block">
                                  <span class="demonstration">Titre entete principal</span>
                                  <el-input name="entete1" type="textarea" autosize placeholder="titre entete principal" v-model="paramGlobal.entete1"></el-input>
                                </div>
                              </v-flex>

                              <v-flex md4>
                                <div class="block">
                                  <span class="demonstration">Titre entete secondaire</span>
                                  <el-input name="entete2" type="textarea" autosize placeholder="titre entete secondaire" v-model="paramGlobal.entete2"></el-input>
                                </div>
                              </v-flex>

                              <v-flex md4>
                                <div class="block">
                                  <span class="demonstration">Pied de page</span>
                                  <el-input name="piedPage" type="textarea" autosize placeholder="pied de page" v-model="paramGlobal.piedPage"></el-input>
                                </div>
                              </v-flex>
                            </v-layout>

                            <v-layout row>
                               <v-flex md4>
                                <div class="block">
                                  <span class="demonstration">Responsable technique</span>
                                  <el-select filterable v-model="paramGlobal.idRespoTechnik" placeholder="Responsable technique" style="width:100%">
                                    <el-option v-for="item in users" :key="item.id" :label="item.nom" :value="item.id">
                                    </el-option>
                                  </el-select>
                                </div>
                              </v-flex>

                              <v-flex md4>
                                <el-upload class="upload-demo" name="logo" action="" ref="upload" :auto-upload="false" :file-list="fileLogo" list-type="picture">
                                  <el-button size="small" type="primary">CLIQUER ICI <i class="el-icon-picture"></i></el-button>
                                </el-upload>
                              </v-flex>
                            </v-layout>

                            <v-btn icons color="orange" @click="retour()" dark><v-icon>keyboard_backspace</v-icon> Retour </v-btn>
                            <v-btn v-if="droitAcces.admin_new_param" icons color="blue" @click="submit()" dark> Enregistrer <v-icon>save</v-icon></v-btn>
                          </v-form>
                        </el-card>
                      </v-container>
                    </el-row>
                  </el-tab-pane>
                </el-tabs>

                <!-- CODE -->
                <el-tabs v-if="droitAcces.admin_new_param_code && etatCode">
                  <el-tab-pane>
                    <span slot="label"> Configuration de vos code et identifiant <v-icon right>code</v-icon></span>

                    <el-row>
                      <v-container fluid grid-list-md>
                        <el-card class="box-card">
                          <v-form v-model="valid" ref="formCode" lazy-validation id="formCode">
                            <v-layout row>
                              <v-flex md3>
                                <div class="block">
                                  <span class="demonstration">Utilisateur</span>
                                  <el-input name="user" placeholder="Utilisateur" v-model="paramGlobal.user"></el-input>
                                </div>
                              </v-flex>
                              <v-flex md3>
                                <div class="block">
                                  <span class="demonstration">Fournisseur</span>
                                  <el-input name="fournisseur" placeholder="Fournisseur" v-model="paramGlobal.fournisseur"></el-input>
                                </div>
                              </v-flex>
                              <v-flex md3>
                                <div class="block">
                                  <span class="demonstration">Entrepot</span>
                                  <el-input name="entrepot" placeholder="Entrepot" v-model="paramGlobal.entrepot"></el-input>
                                </div>
                              </v-flex>
                              <v-flex md3>
                                <div class="block">
                                  <span class="demonstration">Caisse</span>
                                  <el-input name="caisse" placeholder="Caisse" v-model="paramGlobal.caisse"></el-input>
                                </div>
                              </v-flex>
                            </v-layout>

                            <v-layout row>
                              <v-flex md3>
                                <div class="block">
                                  <span class="demonstration">Maintenance</span>
                                  <el-input name="maintenance" placeholder="Maintenance" v-model="paramGlobal.maintenance"></el-input>
                                </div>
                              </v-flex>
                              <v-flex md3>
                                <div class="block">
                                  <span class="demonstration">Véhicule</span>
                                  <el-input name="vehicule" placeholder="Véhicule" v-model="paramGlobal.vehicule"></el-input>
                                </div>
                              </v-flex>
                              <v-flex md3>
                                <div class="block">
                                  <span class="demonstration">Projet</span>
                                  <el-input name="projet" placeholder="Projet" v-model="paramGlobal.projet"></el-input>
                                </div>
                              </v-flex>
                              <v-flex md3>
                                <div class="block">
                                  <span class="demonstration">Facture</span>
                                  <el-input name="facture" placeholder="Facture" v-model="paramGlobal.facture"></el-input>
                                </div>
                              </v-flex>
                            </v-layout>

                            <v-layout row>
                              <v-flex md3>
                                <div class="block">
                                  <span class="demonstration">Commande</span>
                                  <el-input name="commande" placeholder="Commande" v-model="paramGlobal.commande"></el-input>
                                </div>
                              </v-flex>
                              <v-flex md3>
                                <div class="block">
                                  <span class="demonstration">Livraison</span>
                                  <el-input name="livraison" placeholder="Livraison" v-model="paramGlobal.livraison"></el-input>
                                </div>
                              </v-flex>
                              <v-flex md3>
                                <div class="block">
                                  <span class="demonstration">Approvisionnement</span>
                                  <el-input name="appro" placeholder="Approvisionnement" v-model="paramGlobal.appro"></el-input>
                                </div>
                              </v-flex>
                              <v-flex md3>
                                <div class="block">
                                  <span class="demonstration">Créditer la caisse</span>
                                  <el-input name="approCaisse" placeholder="Créditer la caisse" v-model="paramGlobal.approCaisse"></el-input>
                                </div>
                              </v-flex>
                            </v-layout>

                            <v-layout row>
                              <v-flex md3>
                                <div class="block">
                                  <span class="demonstration">Stock</span>
                                  <el-input name="stock" placeholder="Stock" v-model="paramGlobal.stock"></el-input>
                                </div>
                              </v-flex>
                              <v-flex md3>
                                <div class="block">
                                  <span class="demonstration">Sortir d'entrepot</span>
                                  <el-input name="sortir" placeholder="Sortir d'entrepot" v-model="paramGlobal.sortir"></el-input>
                                </div>
                              </v-flex>
                              <v-flex md3>
                                <div class="block">
                                  <span class="demonstration">Retour d'entrepot</span>
                                  <el-input name="entree" placeholder="Retour d'entrepot" v-model="paramGlobal.entree"></el-input>
                                </div>
                              </v-flex>
                              <v-flex md3>
                                <div class="block">
                                  <span class="demonstration">Transfert</span>
                                  <el-input name="transfert" placeholder="Transfert" v-model="paramGlobal.transfert"></el-input>
                                </div>
                              </v-flex>
                            </v-layout>

                            <v-layout row>
                              <v-flex md3>
                                <div class="block">
                                  <span class="demonstration">Inventaire</span>
                                  <el-input name="inventaire" placeholder="Inventaire" v-model="paramGlobal.inventaire"></el-input>
                                </div>
                              </v-flex>
                              <v-flex md3>
                                <div class="block">
                                  <span class="demonstration">Produit</span>
                                  <el-input name="produit" placeholder="Produit" v-model="paramGlobal.produit"></el-input>
                                </div>
                              </v-flex>
                              <v-flex md3>
                                <div class="block">
                                  <span class="demonstration">Paiement</span>
                                  <el-input name="paiement" placeholder="Paiement" v-model="paramGlobal.paiement"></el-input>
                                </div>
                              </v-flex>
                              <v-flex md3>
                                <div class="block">
                                  <span class="demonstration">Client</span>
                                  <el-input name="client" placeholder="Client" v-model="paramGlobal.client"></el-input>
                                </div>
                              </v-flex>
                            </v-layout>

                            <v-layout row>
                              <v-flex md3>
                                <div class="block">
                                  <span class="demonstration">Contrat de location</span>
                                  <el-input name="location" placeholder="Contrat de location" v-model="paramGlobal.location"></el-input>
                                </div>
                              </v-flex>
                              <v-flex md3>
                                <div class="block">
                                  <span class="demonstration">Demande d'intervention</span>
                                  <el-input name="intervention" placeholder="Demande d'intervention" v-model="paramGlobal.intervention"></el-input>
                                </div>
                              </v-flex>
                              <v-flex md3>
                                <div class="block">
                                  <span class="demonstration">Viste technique</span>
                                  <el-input name="visite" placeholder="Viste technique" v-model="paramGlobal.visite"></el-input>
                                </div>
                              </v-flex>
                              <v-flex md3>
                                <div class="block">
                                  <span class="demonstration">Vignette</span>
                                  <el-input name="vignette" placeholder="Vignette" v-model="paramGlobal.vignette"></el-input>
                                </div>
                              </v-flex>
                            </v-layout>

                            <v-layout row>
                              <v-flex md3>
                                <div class="block">
                                  <span class="demonstration">Assurance</span>
                                  <el-input name="assurance" placeholder="Assurance" v-model="paramGlobal.assurance"></el-input>
                                </div>
                              </v-flex>
                              <v-flex md3>
                                <div class="block">
                                  <span class="demonstration">Mission</span>
                                  <el-input name="mission" placeholder="Mission" v-model="paramGlobal.mission"></el-input>
                                </div>
                              </v-flex>
                            </v-layout>

                            <br>
                            <v-btn icons color="orange" @click="retour()" dark><v-icon>keyboard_backspace</v-icon> Retour </v-btn>
                            <v-btn v-if="droitAcces.admin_new_param_code" icons color="blue" @click="submitCode()" dark> Ajouter <v-icon>add</v-icon></v-btn>
                            <br>
                          </v-form>
                        </el-card>
                      </v-container>
                    </el-row>
                  </el-tab-pane>
                </el-tabs>

                <!-- ALERT -->
                <el-tabs v-if="droitAcces.admin_new_param_alert && etatAlert">
                  <el-tab-pane>
                    <span slot="label"> Alert et notification (Mail / SMS) <v-icon right>add_alert</v-icon></span>

                    <el-alert
                      title="ATTENTION"
                      type="warning"
                      description="VEUILLEZ EVITER LES CARACTERES SPECIAUX SUIVANT <<()>>  "
                      show-icon>
                    </el-alert>
                    <el-row :gutter="20">
                      <v-container fluid grid-list-md>
                        <v-form v-model="valid" ref="formAlert"  id="formAlert">
                          <el-card class="box-card">
                            <el-tabs v-model="envoieAlert">

                              <el-tab-pane label="CAISSE" name="caisse" >
                                <p align="center">
                                  <v-chip text-color="white" label color="primary" style="font-size:22px; width:100%">
                                    CAISSE
                                  </v-chip>
                                </p>

                                <v-form id="caisseParam"  ref="caisseParam" lazy-validation  >
                                <v-layout row>
                                  <v-flex md6>
                                    <div class="block">
                                      <span class="demonstration">SMS seuil minimun atteint caisse</span>
                                      <el-input name="smsSeuilCaisse" type="textarea" autosize placeholder="SMS seuil minimum atteint caisse" v-model="paramGlobal.smsSeuilCaisse"></el-input>
                                    </div>
                                  </v-flex>
                                  <v-flex md6>
                                    <div class="block">
                                      <span class="demonstration">Mail minimun atteint caisse</span>
                                      <el-input name="mailSeuilCaisse" type="textarea" autosize placeholder="Mail minimum atteint caisse" v-model="paramGlobal.mailSeuilCaisse"></el-input>
                                    </div>
                                  </v-flex>
                                </v-layout>

                                <v-layout row>
                                  <v-flex md6>
                                    <div class="block">
                                      <span class="demonstration">SMS nouvelle caisse</span>
                                      <el-input name="smsCaisse" type="textarea" autosize placeholder="SMS nouvelle caisse" v-model="paramGlobal.smsCaisse"></el-input>
                                    </div>
                                  </v-flex>
                                  <v-flex md6>
                                    <div class="block">
                                      <span class="demonstration">Mail nouvelle caisse</span>
                                      <el-input name="mailCaisse" type="textarea" autosize placeholder="Mail nouvelle caisse" v-model="paramGlobal.mailCaisse"></el-input>
                                    </div>
                                  </v-flex>
                                </v-layout>



                                <v-layout row>
                                  <v-flex md6>
                                    <div class="block">
                                      <span class="demonstration">SMS nouveau approvisionnement de la caisse</span>
                                      <el-input name="smsApproCaisse" type="textarea" autosize placeholder="SMS nouveau approvisionnement de la caisse" v-model="paramGlobal.smsApproCaisse"></el-input>
                                    </div>
                                  </v-flex>
                                  <v-flex md6>
                                    <div class="block">
                                      <span class="demonstration">Mail nouveau approvisionnement de la caisse</span>
                                      <el-input name="mailApproCaisse" type="textarea" autosize placeholder="Mail nouveau approvisionnement de la caisse" v-model="paramGlobal.mailApproCaisse"></el-input>
                                    </div>
                                  </v-flex>
                                </v-layout>

                                <v-layout row>
                                  <v-flex md6>
                                    <div class="block">
                                      <span class="demonstration">SMS validation approvisionnement caisse</span>
                                      <el-input name="smsApproCaisseValid" type="textarea" autosize placeholder="SMS validation approvisionnement caisse" v-model="paramGlobal.smsApproCaisseValid"></el-input>
                                    </div>
                                  </v-flex>
                                  <v-flex md6>
                                    <div class="block">
                                      <span class="demonstration">Mail validation approvisionnement caisse</span>
                                      <el-input name="mailApproCaisseValid" type="textarea" autosize placeholder="Mail validation approvisionnement caisse" v-model="paramGlobal.mailApproCaisseValid"></el-input>
                                    </div>
                                  </v-flex>
                                </v-layout>

                                <v-layout row>
                                  <v-flex md6>
                                    <div class="block">
                                      <span class="demonstration">SMS nouveau paiement</span>
                                      <el-input name="smsPaiement" type="textarea" autosize placeholder="SMS nouveau paiement" v-model="paramGlobal.smsPaiement"></el-input>
                                    </div>
                                  </v-flex>
                                  <v-flex md6>
                                    <div class="block">
                                      <span class="demonstration">Mail nouveau paiement</span>
                                      <el-input name="mailPaiement" type="textarea" autosize placeholder="Mail nouveau paiement" v-model="paramGlobal.mailPaiement"></el-input>
                                    </div>
                                  </v-flex>
                                </v-layout>
                                <br>

                                <v-btn icons color="orange" @click="retour()" dark><v-icon>keyboard_backspace</v-icon> Retour </v-btn>
                                <v-btn v-if="droitAcces.admin_new_param_alert" icons color="blue" @click="submitAlert('caisseParam')" dark> Ajouter <v-icon>add</v-icon></v-btn>
                                <br>
                                </v-form>

                              </el-tab-pane>


                              <el-tab-pane label="MAINTENANCE" name="maintenance">
                                <p align="center">
                                  <v-chip text-color="white" label color="primary" style="font-size:22px; width:100%">
                                    MAINTENANCE
                                  </v-chip>
                                </p>

                                <v-form id="maintenanceParam"  ref="maintenanceParam" lazy-validation >
                                <v-layout row>
                                  <v-flex md6>
                                    <div class="block">
                                      <span class="demonstration">SMS Ajout de zone</span>
                                      <el-input name="smsZone" type="textarea" autosize placeholder="SMS Ajout de zone" v-model="paramGlobal.smsZone"></el-input>
                                    </div>
                                  </v-flex>
                                  <v-flex md6>
                                    <div class="block">
                                      <span class="demonstration">Mail Ajout de zone</span>
                                      <el-input name="mailZone" type="textarea" autosize placeholder="Mail Ajout de zone" v-model="paramGlobal.mailZone"></el-input>
                                    </div>
                                  </v-flex>
                                </v-layout>

                                <!-- <v-layout row>
                                  <v-flex md6>
                                    <div class="block">
                                      <span class="demonstration">SMS Ajout de demande</span>
                                      <el-input name="smsDemande" type="textarea" autosize placeholder="SMS Ajout de demande" v-model="paramGlobal.smsDemande"></el-input>
                                    </div>
                                  </v-flex>
                                  <v-flex md6>
                                    <div class="block">
                                      <span class="demonstration">Mail Ajout de demande</span>
                                      <el-input name="mailDemande" type="textarea" autosize placeholder="Mail Ajout de demande" v-model="paramGlobal.mailDemande"></el-input>
                                    </div>
                                  </v-flex>
                                </v-layout> -->

                                <v-layout row>
                                  <v-flex md6>
                                    <div class="block">
                                      <span class="demonstration">SMS Ajout de constat</span>
                                      <el-input name="smsConstat" type="textarea" autosize placeholder="SMS Ajout de constat" v-model="paramGlobal.smsConstat"></el-input>
                                    </div>
                                  </v-flex>
                                  <v-flex md6>
                                    <div class="block">
                                      <span class="demonstration">Mail Ajout de constat</span>
                                      <el-input name="mailConstat" type="textarea" autosize placeholder="Mail Ajout de constat" v-model="paramGlobal.mailConstat"></el-input>
                                    </div>
                                  </v-flex>
                                </v-layout>

                                <v-layout row>
                                  <v-flex md6>
                                    <div class="block">
                                      <span class="demonstration">SMS Ajout de validation de constat</span>
                                      <el-input name="smsConstatValid" type="textarea" autosize placeholder="SMS Ajout de validation de constat" v-model="paramGlobal.smsConstatValid"></el-input>
                                    </div>
                                  </v-flex>
                                  <v-flex md6>
                                    <div class="block">
                                      <span class="demonstration">Mail de validation Ajout de constat</span>
                                      <el-input name="mailConstatValid" type="textarea" autosize placeholder="Mail de validation Ajout de constat" v-model="paramGlobal.mailConstatValid"></el-input>
                                    </div>
                                  </v-flex>
                                </v-layout>

                                <v-layout row>
                                  <v-flex md6>
                                    <div class="block">
                                      <span class="demonstration">SMS ajout d'une intervention</span>
                                      <el-input name="smsIntervention" type="textarea" autosize placeholder="SMS Ajout d'une intervention" v-model="paramGlobal.smsIntervention"></el-input>
                                    </div>
                                  </v-flex>
                                  <v-flex md6>
                                    <div class="block">
                                      <span class="demonstration">Mail ajout d'une intervention</span>
                                      <el-input name="mailIntervention" type="textarea" autosize placeholder="Mail Ajout d'une intervention" v-model="paramGlobal.mailIntervention"></el-input>
                                    </div>
                                  </v-flex>
                                </v-layout>

                                <v-layout row>
                                  <v-flex md6>
                                    <div class="block">
                                      <span class="demonstration">SMS ajout de fin de travaux</span>
                                      <el-input name="smsTravaux" type="textarea" autosize placeholder="SMS ajout de fin de travaux" v-model="paramGlobal.smsTravaux"></el-input>
                                    </div>
                                  </v-flex>
                                  <v-flex md6>
                                    <div class="block">
                                      <span class="demonstration">Mail ajout de fin de travaux</span>
                                      <el-input name="mailTravaux" type="textarea" autosize placeholder="Mail ajout de fin de travaux" v-model="paramGlobal.mailTravaux"></el-input>
                                    </div>
                                  </v-flex>
                                </v-layout>
                                <br>

                                <v-btn icons color="orange" @click="retour()" dark><v-icon>keyboard_backspace</v-icon> Retour </v-btn>
                                <v-btn v-if="droitAcces.admin_new_param_alert" icons color="blue" @click="submitAlert('maintenanceParam')" dark> Ajouter <v-icon>add</v-icon></v-btn>
                                <br>
                                </v-form>
                              </el-tab-pane>
                              <el-tab-pane label="PRESTATAIRE" name="prestataire">
                                <p align="center">
                                  <v-chip text-color="white" label color="primary" style="font-size:22px; width:100%">
                                    PRESTATAIRE
                                  </v-chip>
                                </p>

                                <v-form id="prestataireParam"  ref="prestataireParam" lazy-validation >
                                <v-layout row>
                                  <v-flex md6>
                                    <div class="block">
                                      <span class="demonstration">SMS Ajout de prestataire</span>
                                      <el-input name="smsPrestataire" type="textarea" autosize placeholder="SMS Ajout de prestataire" v-model="paramGlobal.smsPrestataire"></el-input>
                                    </div>
                                  </v-flex>
                                  <v-flex md6>
                                    <div class="block">
                                      <span class="demonstration">Mail Ajout de prestataire</span>
                                      <el-input name="mailPrestataire" type="textarea" autosize placeholder="Mail Ajout de prestataire" v-model="paramGlobal.mailPrestataire"></el-input>
                                    </div>
                                  </v-flex>
                                </v-layout>


                                <v-layout row>
                                  <v-flex md6>
                                    <div class="block">
                                      <span class="demonstration">SMS Ajout de devis</span>
                                      <el-input name="smsDevis" type="textarea" autosize placeholder="SMS Ajout de devis" v-model="paramGlobal.smsDevis"></el-input>
                                    </div>
                                  </v-flex>
                                  <v-flex md6>
                                    <div class="block">
                                      <span class="demonstration">Mail Ajout de devis</span>
                                      <el-input name="mailDevis" type="textarea" autosize placeholder="Mail Ajout de devis" v-model="paramGlobal.mailDevis"></el-input>
                                    </div>
                                  </v-flex>
                                </v-layout>

                                <v-layout row>
                                  <v-flex md6>
                                    <div class="block">
                                      <span class="demonstration">SMS Ajout de validation de devis</span>
                                      <el-input name="smsDevisValid" type="textarea" autosize placeholder="SMS Ajout de validation de devis" v-model="paramGlobal.smsDevisValid"></el-input>
                                    </div>
                                  </v-flex>
                                  <v-flex md6>
                                    <div class="block">
                                      <span class="demonstration">Mail Ajout de validation de devis</span>
                                      <el-input name="mailDevisValid" type="textarea" autosize placeholder="Mail Ajout de validation de devis" v-model="paramGlobal.mailDevisValid"></el-input>
                                    </div>
                                  </v-flex>
                                </v-layout>

                                <v-layout row>
                                  <v-flex md6>
                                    <div class="block">
                                      <span class="demonstration">SMS Ajout d'approvisionnement</span>
                                      <el-input name="smsAppro" type="textarea" autosize placeholder="SMS Ajout d'approvisionnement" v-model="paramGlobal.smsAppro"></el-input>
                                    </div>
                                  </v-flex>
                                  <v-flex md6>
                                    <div class="block">
                                      <span class="demonstration">Mail Ajout d'approvisionnement</span>
                                      <el-input name="mailAppro" type="textarea" autosize placeholder="Mail Ajout d'approvisionnement" v-model="paramGlobal.mailAppro"></el-input>
                                    </div>
                                  </v-flex>
                                </v-layout>


                                <br>
                                <v-btn icons color="orange" @click="retour()" dark><v-icon>keyboard_backspace</v-icon> Retour </v-btn>
                                <v-btn v-if="droitAcces.admin_new_param_alert" icons color="blue" @click="submitAlert('prestataireParam')" dark> Ajouter <v-icon>add</v-icon></v-btn>
                                <br>
                                </v-form>
                              </el-tab-pane>
                              <el-tab-pane label="MISSION" name="mission">
                                <p align="center">
                                  <v-chip text-color="white" label color="primary" style="font-size:22px; width:100%">
                                    MISSION
                                  </v-chip>
                                </p>

                                <v-form id="parcParam"  ref="parcParam" lazy-validation >
                                <v-layout row>
                                  <v-flex md6>
                                    <div class="block">
                                      <span class="demonstration">SMS demande de mission</span>
                                      <el-input name="smsDemandeMission" type="textarea" autosize placeholder="SMS demande de mission" v-model="paramGlobal.smsDemandeMission"></el-input>
                                    </div>
                                  </v-flex>
                                  <v-flex md6>
                                    <div class="block">
                                      <span class="demonstration">Mail demande de mission</span>
                                      <el-input name="mailDemandeMission" type="textarea" autosize placeholder="Mail demande de mission" v-model="paramGlobal.mailDemandeMission"></el-input>
                                    </div>
                                  </v-flex>
                                </v-layout>
                                <v-layout row>
                                  <v-flex md6>
                                    <div class="block">
                                      <span class="demonstration">SMS première étape de validation d'une mission </span>
                                      <el-input name="smsValid1mission" type="textarea" autosize placeholder="SMS première étape de validation d'une mission" v-model="paramGlobal.smsValid1mission"></el-input>
                                    </div>
                                  </v-flex>
                                  <v-flex md6>
                                    <div class="block">
                                      <span class="demonstration">Mail première étape de validation d'une mission</span>
                                      <el-input name="mailValid1mission" type="textarea" autosize placeholder="Mail première étape de validation d'une mission" v-model="paramGlobal.mailValid1mission"></el-input>
                                    </div>
                                  </v-flex>
                                </v-layout>
                                <v-layout row>
                                  <v-flex md6>
                                    <div class="block">
                                      <span class="demonstration">SMS cloturer une mission </span>
                                      <el-input name="smsCloturmission" type="textarea" autosize placeholder="SMS cloturer une mission" v-model="paramGlobal.smsCloturmission"></el-input>
                                    </div>
                                  </v-flex>
                                  <v-flex md6>
                                    <div class="block">
                                      <span class="demonstration">Mail cloturer une mission</span>
                                      <el-input name="mailCloturmission" type="textarea" autosize placeholder="Mail cloturer une mission" v-model="paramGlobal.mailCloturmission"></el-input>
                                    </div>
                                  </v-flex>
                                </v-layout>
                                <v-layout row>
                                  <v-flex md6>
                                    <div class="block">
                                      <span class="demonstration">SMS seconde étape de validation d'une mission</span>
                                      <el-input name="smsValid2mission" type="textarea" autosize placeholder="SMS seconde étape de validation d'une mission" v-model="paramGlobal.smsValid2mission"></el-input>
                                    </div>
                                  </v-flex>
                                  <v-flex md6>
                                    <div class="block">
                                      <span class="demonstration">Mail seconde étape de validation d'une mission</span>
                                      <el-input name="mailValid2mission" type="textarea" autosize placeholder="Mail seconde étape de validation d'une mission" v-model="paramGlobal.mailValid2mission"></el-input>
                                    </div>
                                  </v-flex>
                                </v-layout>
                                <v-layout row>
                                  <v-flex md6>
                                    <div class="block">
                                      <span class="demonstration">SMS rejet d'une mission</span>
                                      <el-input name="smsRejetMission" type="textarea" autosize placeholder="SMS rejet d'une mission" v-model="paramGlobal.smsRejetMission"></el-input>
                                    </div>
                                  </v-flex>
                                  <v-flex md6>
                                    <div class="block">
                                      <span class="demonstration">Mail rejet d'une mission</span>
                                      <el-input name="mailRejetMission" type="textarea" autosize placeholder="Mail rejet d'une mission" v-model="paramGlobal.mailRejetMission"></el-input>
                                    </div>
                                  </v-flex>
                                </v-layout>

                                <!-- ma modiff -->
                                <br>

                                <v-btn icons color="orange" @click="retour()" dark><v-icon>keyboard_backspace</v-icon> Retour </v-btn>
                                <v-btn v-if="droitAcces.admin_new_param_alert" icons color="blue" @click="submitAlert('parcParam')" dark> Ajouter <v-icon>add</v-icon></v-btn>
                                <br>
                                </v-form>
                              </el-tab-pane>

                              <el-tab-pane label="INTERVENTION" name="intervention">
                                <p align="center">
                                  <v-chip text-color="white" label color="primary" style="font-size:22px; width:100%">
                                    INTERVENTION
                                  </v-chip>
                                </p>

                                <v-form id="parcInterv"  ref="parcInterv" lazy-validation >
                                  <!-- ma modiff -->
                                  <v-layout row>
                                    <v-flex md6>
                                      <div class="block">
                                        <span class="demonstration">SMS demande d'intervention</span>
                                        <el-input name="smsDemandeInterv" type="textarea" autosize placeholder="SMS demande d'intervention" v-model="paramGlobal.smsDemandeInterv"></el-input>
                                      </div>
                                    </v-flex>
                                    <v-flex md6>
                                      <div class="block">
                                        <span class="demonstration">Mail demande d'intervention</span>
                                        <el-input name="mailDemandeInterv" type="textarea" autosize placeholder="Mail demande d'intervention" v-model="paramGlobal.mailDemandeInterv"></el-input>
                                      </div>
                                    </v-flex>
                                  </v-layout>
                                  <v-layout row>
                                    <v-flex md6>
                                      <div class="block">
                                        <span class="demonstration">SMS validation d'intervention</span>
                                        <el-input name="smsValidInterv" type="textarea" autosize placeholder="SMS validation d'intervention" v-model="paramGlobal.smsValidInterv"></el-input>
                                      </div>
                                    </v-flex>
                                    <v-flex md6>
                                      <div class="block">
                                        <span class="demonstration">Mail validation d'intervention</span>
                                        <el-input name="mailValidInterv" type="textarea" autosize placeholder="Mail validation d'intervention" v-model="paramGlobal.mailValidInterv"></el-input>
                                      </div>
                                    </v-flex>
                                  </v-layout>

                                  <v-layout row>
                                    <v-flex md6>
                                      <div class="block">
                                        <span class="demonstration">SMS planning d'intervention</span>
                                        <el-input name="smsPlanningInterv" type="textarea" autosize placeholder="SMS planning d'intervention" v-model="paramGlobal.smsPlanningInterv"></el-input>
                                      </div>
                                    </v-flex>
                                    <v-flex md6>
                                      <div class="block">
                                        <span class="demonstration">Mail planning d'intervention</span>
                                        <el-input name="mailPlanningInterv" type="textarea" autosize placeholder="Mail planning d'intervention" v-model="paramGlobal.mailPlanningInterv"></el-input>
                                      </div>
                                    </v-flex>
                                  </v-layout>
                                  <v-layout row>
                                    <v-flex md6>
                                      <div class="block">
                                        <span class="demonstration">SMS fin d'intervention</span>
                                        <el-input name="smsFinInterv" type="textarea" autosize placeholder="SMS fin d'intervention" v-model="paramGlobal.smsFinInterv"></el-input>
                                      </div>
                                    </v-flex>
                                    <v-flex md6>
                                      <div class="block">
                                        <span class="demonstration">Mail fin d'intervention</span>
                                        <el-input name="mailFinInterv" type="textarea" autosize placeholder="Mail fin d'intervention" v-model="paramGlobal.mailFinInterv"></el-input>
                                      </div>
                                    </v-flex>
                                  </v-layout>
                                  <v-layout row>
                                    <v-flex md6>
                                      <div class="block">
                                        <span class="demonstration">SMS rejet d'intervention</span>
                                        <el-input name="smsRejetInterv" type="textarea" autosize placeholder="SMS rejet d'intervention" v-model="paramGlobal.smsRejetInterv"></el-input>
                                      </div>
                                    </v-flex>
                                    <v-flex md6>
                                      <div class="block">
                                        <span class="demonstration">Mail rejet d'intervention</span>
                                        <el-input name="mailRejetInterv" type="textarea" autosize placeholder="Mail rejet d'intervention" v-model="paramGlobal.mailRejetInterv"></el-input>
                                      </div>
                                    </v-flex>
                                  </v-layout>
                                  <br>

                                  <v-btn icons color="orange" @click="retour()" dark><v-icon>keyboard_backspace</v-icon> Retour </v-btn>
                                  <v-btn v-if="droitAcces.admin_new_param_alert" icons color="blue" @click="submitAlert('parcInterv')" dark> Ajouter <v-icon>add</v-icon></v-btn>
                                  <br>
                                </v-form>
                              </el-tab-pane>

                              <el-tab-pane label="DIAGNOSTIQUE" name="diagnostique">
                                <p align="center">
                                  <v-chip text-color="white" label color="primary" style="font-size:22px; width:100%">
                                    DIAGNOSTIQUE
                                  </v-chip>
                                </p>

                                <v-form id="parcDiag"  ref="parcDiag" lazy-validation >

                                  <v-layout row>
                                    <v-flex md6>
                                      <div class="block">
                                        <span class="demonstration">SMS diagnostic d'intervention</span>
                                        <el-input name="smsDiagnostiq" type="textarea" autosize placeholder="SMS diagnostic d'intervention" v-model="paramGlobal.smsDiagnostiq"></el-input>
                                      </div>
                                    </v-flex>
                                    <v-flex md6>
                                      <div class="block">
                                        <span class="demonstration">Mail diagnostic d'intervention</span>
                                        <el-input name="mailDiagnostiq" type="textarea" autosize placeholder="Mail diagnostic d'intervention" v-model="paramGlobal.mailDiagnostiq"></el-input>
                                      </div>
                                    </v-flex>
                                  </v-layout>
                                  <!-- ma modiff -->

                                  <v-layout row>
                                    <v-flex md6>
                                      <div class="block">
                                        <span class="demonstration">SMS validation de diagnostic</span>
                                        <el-input name="smsValidDiagnostiq" type="textarea" autosize placeholder="SMS validation de diagnostic" v-model="paramGlobal.smsValidDiagnostiq"></el-input>
                                      </div>
                                    </v-flex>
                                    <v-flex md6>
                                      <div class="block">
                                        <span class="demonstration">Mail validation de diagnostic</span>
                                        <el-input name="mailValidDiagnostiq" type="textarea" autosize placeholder="Mail validation de diagnostic" v-model="paramGlobal.mailValidDiagnostiq"></el-input>
                                      </div>
                                    </v-flex>
                                  </v-layout>
                                  <br>

                                  <v-btn icons color="orange" @click="retour()" dark><v-icon>keyboard_backspace</v-icon> Retour </v-btn>
                                  <v-btn v-if="droitAcces.admin_new_param_alert" icons color="blue" @click="submitAlert('parcDiag')" dark> Ajouter <v-icon>add</v-icon></v-btn>
                                  <br>
                                </v-form>
                              </el-tab-pane>
                              <el-tab-pane label="DIVERS" name="divers">
                                <p align="center">
                                  <v-chip text-color="white" label color="primary" style="font-size:22px; width:100%">
                                    DIVERS
                                  </v-chip>
                                </p>

                                <v-form id="diversParam"  ref="diversParam" lazy-validation >
                                <v-layout row>
                                  <v-flex md6>
                                    <div class="block">
                                      <span class="demonstration">SMS Ajout de travaux</span>
                                      <el-input name="smsTravaux" type="textarea" autosize placeholder="SMS Ajout de travaux" v-model="paramGlobal.smsTravaux"></el-input>
                                    </div>
                                  </v-flex>
                                  <v-flex md6>
                                    <div class="block">
                                      <span class="demonstration">Mail Ajout de travaux</span>
                                      <el-input name="mailTravaux" type="textarea" autosize placeholder="Mail Ajout de travaux" v-model="paramGlobal.mailTravaux"></el-input>
                                    </div>
                                  </v-flex>
                                </v-layout>

                                <v-layout row>
                                  <v-flex md6>
                                    <div class="block">
                                      <span class="demonstration">SMS Création de la facture d'une commande</span>
                                      <el-input name="smsFactureCommande" type="textarea" autosize placeholder="SMS Création de la facture d'une commande" v-model="paramGlobal.smsFactureCommande"></el-input>
                                    </div>
                                  </v-flex>
                                  <v-flex md6>
                                    <div class="block">
                                      <span class="demonstration">Mail Création de la facture d'une commande</span>
                                      <el-input name="mailFactureCommande" type="textarea" autosize placeholder="Mail Création de la facture d'une commande" v-model="paramGlobal.mailFactureCommande"></el-input>
                                    </div>
                                  </v-flex>
                                </v-layout>

                                <v-layout row>
                                  <v-flex md6>
                                    <div class="block">
                                      <span class="demonstration">SMS Sorti de l'entrepot</span>
                                      <el-input name="smsSortiEntrepot" type="textarea" autosize placeholder="SMS Sorti de l'entrepot" v-model="paramGlobal.smsSortiEntrepot"></el-input>
                                    </div>
                                  </v-flex>
                                  <v-flex md6>
                                    <div class="block">
                                      <span class="demonstration">Mail Sorti de l'entrepot</span>
                                      <el-input name="mailSortiEntrepot" type="textarea" autosize placeholder="Mail Sorti de l'entrepot" v-model="paramGlobal.mailSortiEntrepot"></el-input>
                                    </div>
                                  </v-flex>
                                </v-layout>

                                <v-layout row>
                                  <v-flex md6>
                                    <div class="block">
                                      <span class="demonstration">SMS retour de l'entrepot</span>
                                      <el-input name="smsRetourEntrepot" type="textarea" autosize placeholder="SMS retour de l'entrepot" v-model="paramGlobal.smsRetourEntrepot"></el-input>
                                    </div>
                                  </v-flex>
                                  <v-flex md6>
                                    <div class="block">
                                      <span class="demonstration">Mail retour de l'entrepot</span>
                                      <el-input name="mailRetourEntrepot" type="textarea" autosize placeholder="Mail retour de l'entrepot" v-model="paramGlobal.mailRetourEntrepot"></el-input>
                                    </div>
                                  </v-flex>
                                </v-layout>

                                <v-layout row>
                                  <v-flex md6>
                                    <div class="block">
                                      <span class="demonstration">SMS reglement caisse</span>
                                      <el-input name="smsReglementCaisse" type="textarea" autosize placeholder="SMS reglement caisse" v-model="paramGlobal.smsReglementCaisse"></el-input>
                                    </div>
                                  </v-flex>
                                  <v-flex md6>
                                    <div class="block">
                                      <span class="demonstration">Mail reglement caisse</span>
                                      <el-input name="mailReglementCaisse" type="textarea" autosize placeholder="Mail reglement caisse" v-model="paramGlobal.mailReglementCaisse"></el-input>
                                    </div>
                                  </v-flex>
                                </v-layout>

                                <v-layout row>
                                  <v-flex md6>
                                    <div class="block">
                                      <span class="demonstration">SMS création d'un utilisateur</span>
                                      <el-input name="smsCreateUser" type="textarea" autosize placeholder="SMS création d'un utilisateur" v-model="paramGlobal.smsCreateUser"></el-input>
                                    </div>
                                  </v-flex>
                                  <v-flex md6>
                                    <div class="block">
                                      <span class="demonstration">Mail création d'un utilisateur</span>
                                      <el-input name="mailCreateUser" type="textarea" autosize placeholder="Mail création d'un utilisateur" v-model="paramGlobal.mailCreateUser"></el-input>
                                    </div>
                                  </v-flex>
                                </v-layout>

                                <v-layout row>
                                  <v-flex md6>
                                    <div class="block">
                                      <span class="demonstration">SMS changement d'un mot de passe</span>
                                      <el-input name="smsChangePassword" type="textarea" autosize placeholder="SMS changement d'un mot de passe" v-model="paramGlobal.smsChangePassword"></el-input>
                                    </div>
                                  </v-flex>
                                  <v-flex md6>
                                    <div class="block">
                                      <span class="demonstration">Mail changement d'un mot de passe</span>
                                      <el-input name="mailChangePassword" type="textarea" autosize placeholder="Mail changement d'un mot de passe" v-model="paramGlobal.mailChangePassword"></el-input>
                                    </div>
                                  </v-flex>
                                </v-layout>

                                <v-layout row>
                                  <v-flex md6>
                                    <div class="block">
                                      <span class="demonstration">SMS validation demande maintenance</span>
                                      <el-input name="smsValideDmdMaint" type="textarea" autosize placeholder="SMS validation demande maintenance" v-model="paramGlobal.smsValideDmdMaint"></el-input>
                                    </div>
                                  </v-flex>
                                  <v-flex md6>
                                    <div class="block">
                                      <span class="demonstration">Mail validation demande maintenance</span>
                                      <el-input name="mailValideDmdMaint" type="textarea" autosize placeholder="Mail validation demande maintenance" v-model="paramGlobal.mailValideDmdMaint"></el-input>
                                    </div>
                                  </v-flex>
                                </v-layout>

                                <v-layout row>
                                  <v-flex md6>
                                    <div class="block">
                                      <span class="demonstration">SMS validation demande de fond</span>
                                      <el-input name="smsValideDmdFond" type="textarea" autosize placeholder="SMS validation demande de fond" v-model="paramGlobal.smsValideDmdFond"></el-input>
                                    </div>
                                  </v-flex>
                                  <v-flex md6>
                                    <div class="block">
                                      <span class="demonstration">Mail validation demande de fond</span>
                                      <el-input name="mailValideDmdFond" type="textarea" autosize placeholder="Mail validation demande de fond" v-model="paramGlobal.mailValideDmdFond"></el-input>
                                    </div>
                                  </v-flex>
                                </v-layout>

                                <v-layout>
                                  <v-flex md6>
                                    <div class="block">
                                      <span class="demonstration">Mail facture commande</span>
                                      <el-input name="mailFactureCommande" type="textarea" autosize placeholder="Mail validation demande de fond" v-model="paramGlobal.mailFactureCommande"></el-input>
                                    </div>
                                  </v-flex>
                                </v-layout>
                                <v-layout row>
                                  <v-flex md6>
                                    <div class="block">
                                      <span class="demonstration">Mail Livraison d'une commande</span>
                                      <el-input name="mailLivraisonCommande" type="textarea" autosize placeholder="Mail Livraison d'une commande" v-model="paramGlobal.mailLivraisonCommande"></el-input>
                                    </div>
                                  </v-flex>
                                </v-layout>
                                <br>

                                <v-btn icons color="orange" @click="retour()" dark><v-icon>keyboard_backspace</v-icon> Retour </v-btn>
                                <v-btn v-if="droitAcces.admin_new_param_alert" icons color="blue" @click="submitAlert('diversParam')" dark> Ajouter <v-icon>add</v-icon></v-btn>
                                <br>
                                </v-form>
                              </el-tab-pane>
                               <el-tab-pane label="PROJET" name="projet">
                                <p align="center">
                                  <v-chip text-color="white" label color="primary" style="font-size:22px; width:100%">
                                    PROJET
                                  </v-chip>
                                </p>

                                <v-form id="projetParam"  ref="projetParam" lazy-validation >
                                <v-layout row>
                                  <v-flex md6>
                                    <div class="block">
                                      <span class="demonstration">SMS Ajout d'un nouveau projet</span>
                                      <el-input name="smsProjet" type="textarea" autosize placeholder="SMS Ajout d'un nouveau projet" v-model="paramGlobal.smsProjet"></el-input>
                                    </div>
                                  </v-flex>
                                  <v-flex md6>
                                    <div class="block">
                                      <span class="demonstration">Mail Ajout d'un nouveau projet</span>
                                      <el-input name="mailProjet" type="textarea" autosize placeholder="Mail Ajout d'un nouveau projet" v-model="paramGlobal.mailProjet"></el-input>
                                    </div>
                                </v-flex>
                                  </v-layout>

                                <v-layout row>
                                   <v-flex md6>
                                    <div class="block">
                                      <span class="demonstration">SMS Ajout d'un nouveau chantier</span>
                                      <el-input name="smsChantier" type="textarea" autosize placeholder="SMS Ajout d'un nouveau chantier" v-model="paramGlobal.smsChantier"></el-input>
                                    </div>
                                  </v-flex>
                                  <v-flex md6>
                                    <div class="block">
                                      <span class="demonstration">Mail Ajout d'un nouveau chantier</span>
                                      <el-input name="mailChantier" type="textarea" autosize placeholder="MAil Ajout d'un nouveau chantier" v-model="paramGlobal.mailChantier"></el-input>
                                    </div>
                                  </v-flex>
                                   </v-layout>

                                  <v-layout row>
                                     <v-flex md6>
                                    <div class="block">
                                      <span class="demonstration">SMS Ajout de nouveau travaux</span>
                                      <el-input name="smsTravauxProjet" type="textarea" autosize placeholder="SMS Ajout de nouveau travaux" v-model="paramGlobal.smsTravauxProjet"></el-input>
                                    </div>
                                  </v-flex>
                                  <v-flex md6>
                                    <div class="block">
                                      <span class="demonstration">Mail Ajout de nouveau travaux</span>
                                      <el-input name="mailTravauxProjet" type="textarea" autosize placeholder="Mail Ajout de nouveau travaux" v-model="paramGlobal.mailTravauxProjet"></el-input>
                                    </div>
                                  </v-flex>
                                   </v-layout>

                                   <v-layout row>
                                     <v-flex md6>
                                    <div class="block">
                                      <span class="demonstration">SMS Planification de besoins matériels</span>
                                      <el-input name="smsPlanifBesoin" type="textarea" autosize placeholder="SMS Ajout Planification de besoins matériels" v-model="paramGlobal.smsPlanifBesoin"></el-input>
                                    </div>
                                  </v-flex>
                                  <v-flex md6>
                                    <div class="block">
                                      <span class="demonstration">Mail Planification de besoins matériels</span>
                                      <el-input name="mailPlanifBesoin" type="textarea" autosize placeholder="Mail Planification de besoins matériels" v-model="paramGlobal.mailPlanifBesoin"></el-input>
                                    </div>
                                  </v-flex>
                                   </v-layout>

                                  <v-layout row>
                                   <v-flex md6>
                                    <div class="block">
                                      <span class="demonstration">SMS Planification des tâches</span>
                                      <el-input name="smsTaches" type="textarea" autosize placeholder="SMS Planification des tâches" v-model="paramGlobal.smsTaches"></el-input>
                                    </div>
                                  </v-flex>
                                  <v-flex md6>
                                    <div class="block">
                                      <span class="demonstration">Mail Planification des tâches</span>
                                      <el-input name="mailTaches" type="textarea" autosize placeholder="Mail Planification des tâches" v-model="paramGlobal.mailTaches"></el-input>
                                    </div>
                                  </v-flex>
                                </v-layout>

                                <v-layout row>
                                     <v-flex md6>
                                    <div class="block">
                                      <span class="demonstration">SMS Validation de besoins matériels</span>
                                      <el-input name="smsValidBesoinMateriel" type="textarea" autosize placeholder="SMS Ajout Validation de besoins matériels" v-model="paramGlobal.smsValidBesoinMateriel"></el-input>
                                    </div>
                                  </v-flex>
                                  <v-flex md6>
                                    <div class="block">
                                      <span class="demonstration">Mail Validation de besoins matériels</span>
                                      <el-input name="mailValidBesoinMateriel" type="textarea" autosize placeholder="Mail Validation de besoins matériels" v-model="paramGlobal.mailValidBesoinMateriel"></el-input>
                                    </div>
                                  </v-flex>
                                   </v-layout>

                                <br>

                                <v-btn icons color="orange" @click="retour()" dark><v-icon>keyboard_backspace</v-icon> Retour </v-btn>
                                <v-btn v-if="droitAcces.admin_new_param_alert" icons color="blue" @click="submitAlert('projetParam')" dark> Ajouter <v-icon>add</v-icon></v-btn>
                                <br>
                                </v-form>
                              </el-tab-pane>

                              <el-tab-pane label="BESOINS" name="besoins">
                                <p align="center">
                                  <v-chip text-color="white" label color="primary" style="font-size:22px; width:100%">
                                    BESOINS
                                  </v-chip>
                                </p>

                                <v-form id="besoinParam"  ref="besoinParam" lazy-validation >
                                <v-layout row>
                                  <v-flex md6>
                                    <div class="block">
                                      <span class="demonstration">SMS Ajout de besoin</span>
                                      <el-input name="smsBesoin" type="textarea" autosize placeholder="SMS Ajout de besoin" v-model="paramGlobal.smsBesoin"></el-input>
                                    </div>
                                  </v-flex>
                                  <v-flex md6>
                                    <div class="block">
                                      <span class="demonstration">Mail Ajout de besoin</span>
                                      <el-input name="mailBesoin" type="textarea" autosize placeholder="Mail Ajout de Besoin" v-model="paramGlobal.mailBesoin"></el-input>
                                    </div>
                                  </v-flex>
                                </v-layout>

                                <v-layout row>
                                  <v-flex md6>
                                    <div class="block">
                                      <span class="demonstration">SMS Validation du besoin</span>
                                      <el-input name="smsValidBesoin" type="textarea" autosize placeholder="SMS validation du besoin" v-model="paramGlobal.smsValidBesoin"></el-input>
                                    </div>
                                  </v-flex>
                                  <v-flex md6>
                                    <div class="block">
                                      <span class="demonstration">Mail Validation du besoin</span>
                                      <el-input name="mailValidBesoin" type="textarea" autosize placeholder="Mail validation du besoin" v-model="paramGlobal.mailValidBesoin"></el-input>
                                    </div>
                                  </v-flex>
                                </v-layout>

                                  <v-layout row>
                                  <v-flex md6>
                                    <div class="block">
                                      <span class="demonstration">SMS Comparateur de commande du besoin</span>
                                      <el-input name="smsCmdComparateur" type="textarea" autosize placeholder="SMS Comparateur de commande du besoin" v-model="paramGlobal.smsCmdComparateur"></el-input>
                                    </div>
                                  </v-flex>
                                  <v-flex md6>
                                    <div class="block">
                                      <span class="demonstration">Mail Comparateur de commande du besoin</span>
                                      <el-input name="mailCmdComparateur" type="textarea" autosize placeholder="Mail Comparateur de commande du besoin" v-model="paramGlobal.mailCmdComparateur"></el-input>
                                    </div>
                                  </v-flex>
                                </v-layout>

                                <br>

                                <v-btn icons color="orange" @click="retour()" dark><v-icon>keyboard_backspace</v-icon> Retour </v-btn>
                                <v-btn v-if="droitAcces.admin_new_param_alert" icons color="blue" @click="submitAlert('besoinParam')" dark> Ajouter <v-icon>add</v-icon></v-btn>
                                <br>
                                </v-form>
                              </el-tab-pane>


                               <el-tab-pane label="FOURNISSEUR" name="fournisseur">
                                <p align="center">
                                  <v-chip text-color="white" label color="primary" style="font-size:22px; width:100%">
                                    FOURNISSEUR
                                  </v-chip>
                                </p>
                                <v-form id="fournisseurParam"  ref="fournisseurParam" lazy-validation >
                                <v-layout row>
                                  <v-flex md6>
                                    <div class="block">
                                      <span class="demonstration">SMS Ajout de commande</span>
                                      <el-input name="smsCommande" type="textarea" autosize placeholder="SMS Ajout de commande" v-model="paramGlobal.smsCommande"></el-input>
                                    </div>
                                  </v-flex>
                                  <v-flex md6>
                                    <div class="block">
                                      <span class="demonstration">Mail Ajout de commande</span>
                                      <el-input name="mailCommande" type="textarea" autosize placeholder="Mail Ajout de commande" v-model="paramGlobal.mailCommande"></el-input>
                                    </div>
                                  </v-flex>
                                </v-layout>

                                <v-layout row>
                                  <v-flex md6>
                                    <div class="block">
                                      <span class="demonstration">SMS Ajout de facture</span>
                                      <el-input name="smsFacture" type="textarea" autosize placeholder="SMS Ajout de facture" v-model="paramGlobal.smsFacture"></el-input>
                                    </div>
                                  </v-flex>
                                  <v-flex md6>
                                    <div class="block">
                                      <span class="demonstration">Mail Ajout de facture</span>
                                      <el-input name="mailFacture" type="textarea" autosize placeholder="Mail Ajout de facture" v-model="paramGlobal.mailFacture"></el-input>
                                    </div>
                                  </v-flex>
                                </v-layout>

                                <v-layout row>
                                  <v-flex md6>
                                    <div class="block">
                                      <span class="demonstration">SMS Ajout de livraison</span>
                                      <el-input name="smsLivraison" type="textarea" autosize placeholder="SMS Ajout de livraison" v-model="paramGlobal.smsLivraison"></el-input>
                                    </div>
                                  </v-flex>
                                  <v-flex md6>
                                    <div class="block">
                                      <span class="demonstration">Mail Ajout de livraison</span>
                                      <el-input name="mailLivraison" type="textarea" autosize placeholder="Mail Ajout de livraison" v-model="paramGlobal.mailLivraison"></el-input>
                                    </div>
                                  </v-flex>
                                </v-layout>

                                  <v-layout row>
                                  <v-flex md6>
                                    <div class="block">
                                      <span class="demonstration">SMS transformation commande en facture</span>
                                      <el-input name="smsCmdeFacture" type="textarea" autosize placeholder="SMS transformation commande en produit" v-model="paramGlobal.smsCmdeFacture"></el-input>
                                    </div>
                                  </v-flex>
                                  <v-flex md6>
                                    <div class="block">
                                      <span class="demonstration">Mail transformation commande en facture</span>
                                      <el-input name="mailCmdeFacture" type="textarea" autosize placeholder="Mail transformation commande en produit" v-model="paramGlobal.mailCmdeFacture"></el-input>
                                    </div>
                                  </v-flex>
                                </v-layout>

                                <v-layout row>
                                  <v-flex md6>
                                    <div class="block">
                                      <span class="demonstration">SMS validation de facture</span>
                                      <el-input name="smsFactureValid" type="textarea" autosize placeholder="SMS validation de facture" v-model="paramGlobal.smsFactureValid"></el-input>
                                    </div>
                                  </v-flex>
                                  <v-flex md6>
                                    <div class="block">
                                      <span class="demonstration">Mail validation de facture</span>
                                      <el-input name="mailFactureValid" type="textarea" autosize placeholder="Mail validation de facture" v-model="paramGlobal.mailFactureValid"></el-input>
                                    </div>
                                  </v-flex>
                                </v-layout>


                                <br>

                                <v-btn icons color="orange" @click="retour()" dark><v-icon>keyboard_backspace</v-icon> Retour </v-btn>
                                <v-btn v-if="droitAcces.admin_new_param_alert" icons color="blue" @click="submitAlert('fournisseurParam')" dark> Ajouter <v-icon>add</v-icon></v-btn>
                                <br>
                                </v-form>
                              </el-tab-pane>

                               <el-tab-pane label="LOGISTIQUE" name="parcAuto">
                                <p align="center">
                                  <v-chip text-color="white" label color="primary" style="font-size:22px; width:100%">
                                    LOGISTIQUE
                                  </v-chip>
                                </p>

                                <v-form id="ParcAutoParam"  ref="ParcAutoParam" lazy-validation >
                                <v-layout row>
                                  <v-flex md6>
                                    <div class="block">
                                      <span class="demonstration">SMS Ajout d'une demande</span>
                                      <el-input name="smsDemandeRep" type="textarea" autosize placeholder="SMS Ajout de Demande" v-model="paramGlobal.smsDemandeRep"></el-input>
                                    </div>
                                  </v-flex>
                                  <v-flex md6>
                                    <div class="block">
                                      <span class="demonstration">Mail Ajout d'une demande</span>
                                      <el-input name="mailDemandeRep" type="textarea" autosize placeholder="Mail Ajout de Demande" v-model="paramGlobal.mailDemandeRep"></el-input>
                                    </div>
                                  </v-flex>
                                </v-layout>

                                <!-- <v-layout row>
                                  <v-flex md6>
                                    <div class="block">
                                      <span class="demonstration">SMS Création de la commande analyser par le comparateur </span>
                                      <el-input name="smsCommandeBesoin" type="textarea" autosize placeholder="SMS Création d'une commande de besoin" v-model="paramGlobal.smsCommandeBesoin"></el-input>
                                    </div>
                                  </v-flex>
                                  <v-flex md6>
                                    <div class="block">
                                      <span class="demonstration">Mail Création de la commande analyser par le comparateur</span>
                                      <el-input name="mailCommandeBesoin" type="textarea" autosize placeholder="Mail Création d'une commande de besoin"  v-model="paramGlobal.mailCommandeBesoin"></el-input>
                                    </div>
                                  </v-flex>
                                </v-layout> -->

                                <!-- <v-layout row>
                                  <v-flex md6>
                                    <div class="block">
                                      <span class="demonstration">SMS Validation du besoin</span>
                                      <el-input name="smsValidBesoin" type="textarea" autosize placeholder="SMS validation du besoin" v-model="paramGlobal.smsValidBesoin"></el-input>
                                    </div>
                                  </v-flex>
                                  <v-flex md6>
                                    <div class="block">
                                      <span class="demonstration">Mail Validation du besoin</span>
                                      <el-input name="mailValidBesoin" type="textarea" autosize placeholder="Mail validation du besoin" v-model="paramGlobal.mailValidBesoin"></el-input>
                                    </div>
                                  </v-flex>
                                </v-layout> -->
                                <br>

                                <v-btn icons color="orange" @click="retour()" dark><v-icon>keyboard_backspace</v-icon> Retour </v-btn>
                                <v-btn v-if="droitAcces.admin_new_param_alert" icons color="blue" @click="submitAlert('ParcAutoParam')" dark> Ajouter <v-icon>add</v-icon></v-btn>
                                <br>
                                </v-form>
                              </el-tab-pane>

                            </el-tabs>
                          </el-card>
                        </v-form>
                      </v-container>
                    </el-row>
                  </el-tab-pane>
                </el-tabs>

                <!-- SERVICE -->
                <el-tabs v-if="droitAcces.index_service && etatService">
                  <el-tab-pane>
                    <span slot="label"> Services <v-icon right>pie_chart_outlined</v-icon></span>
                    <v-spacer></v-spacer>

                    <v-btn v-if="droitAcces.new_service" icons color="blue" @click="dialogAjout = true" dark> Ajouter <v-icon>add</v-icon></v-btn>

                    <v-flex xs3 >
                      <el-col :span="2" >
                        <el-popover
                        ref="popover5"
                        placement="top"
                        width="180"
                        trigger="hover"
                        >
                          <p>Veuillez choisir le format d'impression ?</p>
                          <div style="text-align: right; margin: 0">
                            <el-button type="success" size="mini" @click="imprimeListeServ('PDF')">PDF</el-button>
                            <el-button type="primary" size="mini" @click="imprimeListeServ('EXC')">EXCEL</el-button>
                          </div>
                        </el-popover>
                          <div>
                            <el-button v-popover:popover5 type="warning" :disabled="disabledBtnServ"
                                icon="el-icon-printer" >Imprimer la liste
                            </el-button>
                          </div>
                      </el-col>
                    </v-flex> <br/><br/>

                    <el-row :gutter="20" v-loading="loading" element-loading-text="En cours d'enrégistrement ..." element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
                      <v-container fluid grid-list-md>
                        <el-card class="box-card">
                          <data-tables :data="listService" style="width: 100%">
                            <el-table-column prop="libelle" label="Libellé"></el-table-column>
                            <el-table-column prop="chef" label="Chef de service"></el-table-column>
                            <el-table-column label="Actions" fixed="right">
                              <template slot-scope="scope">
                                <v-btn v-if="droitAcces.show_service" icons color="green" @click="showService(scope.row)" fab dark small> <v-icon>folder_open</v-icon>
                                </v-btn>
                                <v-btn v-if="droitAcces.edit_service" icons color="primary" @click="editService(scope.row)" fab dark small> <v-icon>edit</v-icon>
                                </v-btn>
                              </template>
                            </el-table-column>
                          </data-tables>
                        </el-card>
                      </v-container>
                      <v-btn icons color="orange" @click="retour()" dark><v-icon>keyboard_backspace</v-icon> Retour </v-btn>
                    </el-row>
                  </el-tab-pane>
                </el-tabs>

                <!-- ROUTES -->
                <!-- <el-tabs v-if="droitAcces.route_all_application && etatRoute"> -->

                <el-tabs >
                  <el-tab-pane>
                    <span slot="label"> Routes <v-icon right>rounded_corner</v-icon></span>
                    <v-spacer></v-spacer>

                    <el-row :gutter="20" v-loading="loading" element-loading-text="En cours d'enrégistrement ..." element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
                      <v-container fluid grid-list-md>
                        <el-card class="box-card">
                          <data-tables :data="listRoute" style="width: 100%">
                            <el-table-column prop="route" label="Route"></el-table-column>
                            <el-table-column prop="description" label="Libellé"></el-table-column>

                            <el-table-column label="Actions" fixed="right">
                              <template scope="scope">
                                <!-- <v-btn v-if="droitAcces.edit_role_all" icons color="primary" @click="newRole(scope.row)" fab dark small> <v-icon>edit</v-icon> -->
                                <v-btn
                                class="tooltip-btn"
                                title="Modifier"
                                  icons color="primary" @click="newRole(scope.row)" fab dark small> <v-icon>edit</v-icon>
                                </v-btn>
                              </template>
                            </el-table-column>
                          </data-tables>
                        </el-card>
                      </v-container>
                      <v-btn icons color="orange" @click="retour()" dark><v-icon>keyboard_backspace</v-icon> Retour </v-btn>
                    </el-row>
                  </el-tab-pane>
                </el-tabs>

              </el-card>
            </div>
            <br/>
          </el-col>
        </el-row>
      </v-card-text>
      <div style="flex: 1 1 auto;"></div>
    </v-card>

    <!-- MODAL AJOUT DE SERVICE -->
    <v-dialog v-model="dialogAjout" max-width="50%" :overlay="true" scrollable persistent>
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark class="blue">
          <v-toolbar-title>
            <span v-if="dialogEdit != true">Ajouter un nouveau service</span>
            <span v-if="dialogEdit">Modification du service {{serviceCourant.libelle}} </span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="dialogAjout = false" dark><v-icon>close</v-icon> </v-btn>
        </v-toolbar>

        <v-card-text v-loading="loadingService" element-loading-text="En cours d'enrégistrement ..." element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
          <v-form v-model="valid" ref="formService" lazy-validation id="formService">
            <v-container fluid grid-list-md>
              <v-layout row justify>
                <v-flex md6>
                  <v-text-field label="Libellé" name="libelle" v-model="libelle" :rules="libelleRules" required></v-text-field>
                </v-flex>
                <v-flex md6>
                  <v-select label="Responsable de service" name="chef" v-bind:items="users" v-model="selectChef" :rules="chefRules" item-value="id" item-text="nom" chips required></v-select>
                </v-flex>
              </v-layout>
            </v-container>

            <v-btn @click="dialogAjout = false" color="orange" dark>Annuler <v-icon right>remove_circle</v-icon></v-btn>
            <v-btn v-if="droitAcces.edit_service && dialogEdit != true" icons color="blue" @click="submitService" :disabled="!valid" dark>Ajouter <v-icon right>add</v-icon></v-btn>
            <v-btn v-if="droitAcces.edit_service && dialogEdit" icons color="blue" @click="submitService" :disabled="!valid" dark>Modifier <v-icon right>edit</v-icon></v-btn>
          </v-form>
        </v-card-text>

        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>

    <!-- MODAL AJOUT DE ROLE -->
    <v-dialog v-model="dialogRole" max-width="50%" :overlay="true" scrollable persistent>
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark class="blue">
          <v-toolbar-title>
            <span v-if="dialogEdit">Modification du rôle {{routeCourant.description}} </span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="dialogRole = false" dark><v-icon>close</v-icon> </v-btn>
        </v-toolbar>

        <v-card-text v-loading="loadingRole" element-loading-text="En cours d'enrégistrement ..." element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
          <v-form v-model="valid" ref="formRole" lazy-validation id="formRole">
            <v-container fluid grid-list-md>
              <v-layout row justify>
                <v-flex md6>
                  <v-text-field label="Route" v-model="routeCourant.route" :value="routeCourant.route" disabled></v-text-field>
                </v-flex>
                <v-flex md6>
                  <v-text-field label="Libellé" v-model="routeCourant.libelle" :value="routeCourant.libelle" disabled></v-text-field>
                </v-flex>
              </v-layout>

              <v-layout row justify>
                <v-flex md12>
                  <v-text-field label="Description" name="libelle" v-model="libelle" :rules="libelleRules" required></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>

            <v-btn @click="dialogRole = false" color="orange" dark>Annuler <v-icon right>remove_circle</v-icon></v-btn>
            <v-btn v-if="droitAcces.edit_role_all && dialogEdit" icons color="blue" @click="submitRole" :disabled="!valid" dark>Modifier <v-icon right>edit</v-icon></v-btn>
          </v-form>
        </v-card-text>

        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>

    <!-- MODAL SHOW SERVICE -->
    <v-dialog v-model="dialogShow" max-width="50%" :overlay="true" scrollable persistent>
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark class="indigo">
          <v-toolbar-title>Détails du service {{detailService.libelle}}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="dialogShow = false" dark><v-icon>close</v-icon> </v-btn>
        </v-toolbar>

        <v-card-text v-loading="loading" element-loading-text="Veuillez patientez ..." element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
          <el-row :gutter="20">
            <div class="grid-content" style=" padding: 3px">
              <el-row>
                <el-card class="box-card">
                  <div class="grid-content bg-purple">
                    <div class="text item">
                      <v-layout row justify>
                        <v-flex md6>
                          <p><b>Identifiant : </b> {{detailService.id}} </p>
                          <p><b>Libellé : </b> {{detailService.libelle}} </p>
                          <p><b>Responsable de service : </b> {{detailService.chef}} </p>
                        </v-flex>
                        <v-flex md6>
                          <p><b>Date d'enrégistrement : </b> {{detailService.created}} </p>
                          <p><b>Date de modification : </b> {{detailService.modified}} </p>
                        </v-flex>
                      </v-layout>
                    </div>
                  </div>
                </el-card>
              </el-row>
            </div>
            <br/>
          </el-row>

          <v-tooltip top>
            <v-btn slot="activator" icons color="orange" @click.stop="dialogShow = false" dark>Fermer <v-icon right>close</v-icon></v-btn>
            Fermer
          </v-tooltip>
          <v-tooltip top>
            <v-btn v-if="droitAcces.edit_service" slot="activator" icons color="primary" @click.stop="editService(detailService);" dark>Modifier <v-icon right>edit</v-icon></v-btn>
            Modifier
          </v-tooltip>

        </v-card-text>
        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import Loading from '@/components/Loading';

  export default {
    components:{ Loading },
    name: 'Parametre',
    data () {
      return {
        loading: false,
        loadingService: false,
        loadingRole: false,
        domaine: JSON.parse(sessionStorage.getItem('sessionDomaine')),
        user: JSON.parse(sessionStorage.getItem('userInfo')),
        roleAcces: JSON.parse(sessionStorage.getItem('sessionAcces')),
        droitAcces: JSON.parse(sessionStorage.getItem('sessionDroit')),
        racourcis: [
          { path: '/parametre', text: 'Accueil', disabled: false },
          { path: '/keywords', text: 'Paramètres', disabled: false }
        ],
        valid: true,
        etatParam: true,
        etatGlobal: false,
        etatCode: false,
        etatAlert: false,
        etatService: false,
        etatRoute: false,
        dialogAjout: false,
        dialogRole: false,
        dialogEdit: false,
        dialogShow: false,
        paramGlobal: {
          smsProjet:'',
          smsTaches:'',
          smsTravaux:'',
          smsChantier:'',
          mailProjet:'',
          mailTaches:'',
          mailChantier:'',
          mailPlanifBesoin:'',
          smsPlanifBesoin:'',
          mailTravauxProjet:'',
          smsTravauxProjet:'',
          smsCommandeBesoin:'',
          mailCommandeBesoin:'',
          smsBesoin:'',
          mailBesoin:'',
          smsValidBesoinMateriel:'',
          mailValidBesoinMateriel:'',
          smsDemandeMission: '',
          mailDemandeMission: '',
          smsValid1mission: '',
          smsCloturmission:'',
          mailCloturmission:'',
          mailValid1mission: '',
          smsValid2mission: '',
          mailValid2mission: '',
          smsRejetMission: '',
          mailRejetMission: '',
          smsDemandeInterv: '',
          smsValidInterv: '',
          smsDiagnostiq: '',
          smsValidDiagnostiq: '',
          smsPlanningInterv: '',
          smsFinInterv: '',
          smsRejetInterv: '',
          mailDemandeInterv: '',
          mailValidInterv: '',
          mailDiagnostiq: '',
          mailValidDiagnostiq: '',
          mailPlanningInterv: '',
          mailFinInterv: '',
          mailRejetInterv: '',
          idParam: '',
          assurance: '',
          mission: '',
          visite: '',
          vignette: '',
          intervention: '',
          location: '',
          client: '',
          nom: '',
          logo: '',
          formeJuridique: '',
          contact: '',
          siege: '',
          capital: '',
          dg: '',
          user: '',
          fournisseur: '',
          entrepot: '',
          caisse: '',
          maintenance: '',
          vehicule: '',
          projet: '',
          facture: '',
          commande: '',
          livraison: '',
          appro: '',
          approCaisse: '',
          stock: '',
          sortir: '',
          entree: '',
          transfert: '',
          inventaire: '',
          produit: '',
          paiement: '',
          smsPaiement: '',
          mailPaiement: '',
          smsApproCaisse: '',
          mailApproCaisse: '',
          smsApproCaisseValid: '',
          mailApproCaisseValid: '',
          smsCaisse: '',
          mailSeuilCaisse:'',
          smsSeuilCaisse:'',
          mailCaisse: '',
          smsZone: '',
          mailZone: '',
          smsDemandeRep: '',
          mailDemandeRep: '',
          smsConstat: '',
          mailConstat: '',
          smsConstatValid: '',
          mailConstatValid: '',
          smsIntervention: '',
          mailIntervention: '',
          smsTravaux: '',
          mailTravaux: '',
          smsPrestataire: '',
          mailPrestataire: '',
          smsCommande: '',
          mailCommande: '',
          smsFacture: '',
          mailFacture: '',
          smsLivraison: '',
          mailLivraison: '',
          smsDevis: '',
          mailDevis: '',
          smsDevisValid: '',
          mailDevisValid: '',
          smsAppro: '',
          mailAppro: '',
          smsCmdeFacture: '',
          mailCmdeFacture: '',
          smsFactureValid: '',
          mailFactureValid: '',
          idPres: null,
          idValidateurDemande: null,
          idValidateurDevis: null,
          idRespoTechnik: null,
          montantSeuil: 0,
          mail: 0,
          sms: 0
        },
        fileLogo: [{name: '', url: ''}],
        logoUser: "/static/avatar-conducteur.png",

        listParam: [],
        logoUser: "/static/avatar-conducteur.png",
        listService: [],
        users: [],
        libelle: '',
        libelleRules: [ (v) => !!v || "Veuillez renseigner le libellé" ],
        selectChef: null,
        chef: '',
        chefRules: [ (v) => !!v || "Veuillez sélectionner le responsable du service" ],
        serviceCourant: [],
        detailService: [],
        listPrestataire: [],
        listRoute: [],
        routeCourant: [],
        envoieAlert: 'caisse',
        disabledBtnServ: false,
      }
    },
    computed: {
    },
    methods: {
      loadPage () {
        //this.loading = true
      },
      loadUser () {
        let url = this.domaine + 'userCreate/user-list'
        this.$http.get(url).then(response => {
          if (response.body) {
            this.users = response.body
          }
        })
      },
      loadService () {
        let url = this.domaine + 'webService/liste-service'
        this.$http.get(url).then(response => {
          if (response.body) {
            this.listService = response.body.service
            if (this.listService === undefined || this.listService.length == 0) {
                this.disabledBtnServ = true
            } else{
              this.disabledBtnServ = false
            }
          }
        })
      },
      loadParametre () {
        this.loading = true
        let url = this.domaine + 'webService/index/parametre'
        this.$http.get(url).then(response => {
          if (response.body) {
            this.listParam = response.body.param
            //this.paramGlobal.idDirecteur = response.body.param.idDirecteur
            this.loading = false
          }
        })
      },
      loadPrestaire () {
        let url = this.domaine + 'fournisseur/index/prestataire'
        this.$http.get(url).then(response => {
          if (response.body) {
            this.listPrestataire = response.body.prestataire
          }
        })
      },
      loadRoute () {
        this.loading = true
        let url = this.domaine + 'webService/index/route/all'
        this.$http.get(url).then(response => {
          if (response.body) {
            this.listRoute = response.body.route
            this.loading = false
          }
        })
      },
      param () {
        this.etatGlobal = true
        this.etatCode = false
        this.etatParam = false
        this.etatAlert = false
        this.etatService = false
        this.etatRoute = false
        this.newParametre()
      },
      paramCode () {
        this.etatCode = true
        this.etatGlobal = false
        this.etatParam = false
        this.etatAlert = false
        this.etatService = false
        this.etatRoute = false
        this.newParamCode()
      },
      paramAlert () {
        this.etatAlert = true
        this.etatCode = false
        this.etatGlobal = false
        this.etatParam = false
        this.etatService = false
        this.etatRoute = false
        this.newParamAlert()
      },
      paramService () {
        this.etatService = true
        this.etatRoute = false
        this.etatAlert = false
        this.etatCode = false
        this.etatGlobal = false
        this.etatParam = false
      },
      paramRoute () {
        this.etatRoute = true
        this.etatService = false
        this.etatAlert = false
        this.etatCode = false
        this.etatGlobal = false
        this.etatParam = false
      },
      newParametre () {
        this.paramGlobal = this.listParam
        for (let prop in this.fileLogo) {
          this.fileLogo[prop].name = this.listParam.logo
          this.fileLogo[prop].url = this.listParam.url
        }
      },
      newParamCode () {
        this.paramGlobal = this.listParam
      },
      newParamAlert () {
        this.paramGlobal = this.listParam
      },
      newParamService () {
        this.dialogAjout = true
        this.dialogEdit = false
        this.libelle = ''
        this.selectChef = null
      },
      newRole (item) {
        this.routeCourant = item
        this.dialogRole = true
        this.dialogEdit = true
        this.libelle = item.description
      },
      editService (ligne) {
        this.serviceCourant = ligne
        this.dialogAjout = true
        this.dialogEdit = true
        this.libelle = this.serviceCourant.libelle
        this.selectChef = this.serviceCourant.idChef
      },
      showService (ligne) {
        this.dialogShow = true
        this.serviceCourant = ligne
        let url = this.domaine + 'webService/'+ this.serviceCourant.id +'/show/service'
        this.$http.get(url).then(response => {
          if (response.body) {
            this.detailService = response.body.service
          }
        })
      },
      submit () {
        this.loading = true
        if (this.$refs.formGlobal.validate()) {
          var form = document.getElementById('formGlobal')
          var data = new FormData(form)
          data.append('idUser', this.user.id)
          data.append('idParam', this.listParam.idParam)
          data.append('prestataire', this.paramGlobal.idPres)
          data.append('valideDemande', this.paramGlobal.idValidateurDemande)
          data.append('directeur', this.paramGlobal.idDirecteur)
          data.append('valideDevis', this.paramGlobal.idValidateurDevis)
          data.append('respoTechnik', this.paramGlobal.idRespoTechnik)

          let url = this.domaine + 'webService/new/parametre'
          this.$http.post(url, data).then(response => {
            if (response.body) {
              let verif = response.body
              if (verif.code === 1) {
                this.$notify({
                  title: 'MODIFICATION REUSSI',
                  message: 'Paramètres modifié avec succès.',
                  type: 'success',
                  position: 'top-center'
                })
                this.etatGlobal = false
                this.etatParam = true
                this.loadParametre()
                this.loadPage()
                this.loading = false
              } else if (verif.code === 2) {
                this.$message.error(verif.message)
                this.loading = false
              } else if (verif.code === 0) {
                this.$message.error(verif.message)
                this.loading = false
              }
            } else {
              this.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur')
              this.loading = false
            }
          },
          response => {
            this.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur')
            this.loading = false
          })
        } else {
          this.$message.error('Veuillez renseigner les champs obligatoires')
          this.$notify.error({
            title: "ERREUR D'ENREGISTREMENT",
            message: "La configuration n'a pas été enregistré.",
            position: 'top-center'
          })
          this.loading = false
        }
      },
      submitCode () {
        this.loading = true
        if (this.$refs.formCode.validate()) {
          var form = document.getElementById('formCode')
          var data = new FormData(form)
          data.append('idUser', this.user.id)
          data.append('idParam', this.listParam.idParam)
          let url = this.domaine + 'webService/new/parametre/code'
          this.$http.post(url, data).then(response => {
            if (response.body) {
              let verif = response.body
              if (verif.code === 1) {
                this.$notify({
                  title: 'MODIFICATION REUSSI',
                  message: 'Paramètres modifié avec succès.',
                  type: 'success',
                  position: 'top-center'
                })
                this.etatCode = false
                this.etatParam = true
                this.loadParametre()
                this.loadPage()
                this.loading = false
              } else if (verif.code === 2) {
                this.$message.error(verif.message)
                this.loading = false
              } else if (verif.code === 0) {
                this.$message.error(verif.message)
                this.loading = false
              }
            } else {
              this.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur')
              this.loading = false
            }
          },
          response => {
            this.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur')
            this.loading = false
          })
        } else {
          this.$message.error('Veuillez renseigner les champs obligatoires')
          this.$notify.error({
            title: "ERREUR D'ENREGISTREMENT",
            message: "La configuration n'a pas été enregistré.",
            position: 'top-center'
          })
          this.loading = false
        }
      },
      submitAlert (type) {
        this.loading = true
        if (this.$refs.formAlert.validate()) {
          var form = document.getElementById(type)
          var data = new FormData(form)
          data.append('idUser', this.user.id)
          data.append('idParam', this.listParam.idParam)
          data.append('type', type)
          let url = this.domaine + 'webService/new/parametre/alert'  //WebServiceBundle:DefaultWebServiceController

          this.$http.post(url, data).then(response => {
            if (response.body) {
              let verif = response.body
              if (verif.code === 1) {
                this.$notify({
                  title: 'MODIFICATION REUSSI',
                  message: 'Paramètres modifié avec succès.',
                  type: 'success',
                  position: 'top-center'
                })
                this.etatAlert = false
                this.etatParam = true
                this.loadParametre()
                this.loadPage()
                this.loading = false
              } else if (verif.code === 2) {
                this.$message.error(verif.message)
                this.loading = false
              } else if (verif.code === 0) {
                this.$message.error(verif.message)
                this.loading = false
              }
            } else {
              this.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur1')
              this.loading = false
            }
          },
          response => {
            this.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur')
            this.loading = false
          })

        } else {
          this.$message.error('Veuillez renseigner les champs obligatoires')
          this.$notify.error({
            title: "ERREUR D'ENREGISTREMENT",
            message: "La configuration n'a pas été enregistré.",
            position: 'top-center'
          })
          this.loading = false
        }
      },

      submitService () {

        if (this.$refs.formService.validate()) {
            this.loadingService = true
          var form = document.getElementById('formService')
          var data = new FormData(form)
          data.append('idUser', this.user.id)
          data.append('chef', this.selectChef)
          let url = ''
          if (this.serviceCourant.id) {
            url = this.domaine + 'webService/'+ this.serviceCourant.id +'/edit/service'
          } else {
            url = this.domaine + 'webService/new/service'
          }
          this.$http.post(url, data).then(response => {
                  this.loadingService = false
            if (response.body) {

              let verif = response.body
              if (verif.code === 1) {
                if (this.serviceCourant.id) {
                  this.$notify({
                    title: 'MODIFICATION REUSSI',
                    message: 'Service modifié avec succès.',
                    type: 'success',
                    position: 'top-center'
                  })
                } else {
                  this.$notify({
                    title: 'ENREGISTREMENT REUSSI',
                    message: 'Service enregistré avec succès.',
                    type: 'success',
                    position: 'top-center'
                  })
                }
                this.dialogAjout = false
                this.paramService()
                this.loadService()
                this.loadPage()
                this.loadingService = false
              } else if (verif.code === 0) {
                this.$message.error(verif.message)
                this.loadingService = false
              }
            } else {
              this.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur')
              this.loadingService = false
            }
          },
          response => {
            this.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur')
            this.loadingService = false
          })
        } else {
          this.$message.error('Veuillez renseigner les champs obligatoires')
          this.$notify.error({
            title: "ERREUR D'ENREGISTREMENT",
            message: "Le service n'a pas été enregistré.",
            position: 'top-center'
          })
          this.loadingService = false
        }
      },
      submitRole () {
        this.loadingRole = true
        if (this.$refs.formRole.validate()) {
          var form = document.getElementById('formRole')
          var data = new FormData(form)
          data.append('idUser', this.user.id)
          let url = this.domaine + 'webService/'+ this.routeCourant.id +'/edit/role'

          this.$http.post(url, data).then(response => {
            if (response.body) {
              let verif = response.body
              if (verif.code === 1) {
                this.$notify({
                  title: 'ENREGISTREMENT REUSSI',
                  message: 'Rôle enregistré avec succès.',
                  type: 'success',
                  position: 'top-center'
                })

                this.dialogRole = false
                this.loadRoute()
                this.loadPage()
                this.loadingRole = false
              } else if (verif.code === 0) {
                this.$message.error(verif.message)
                this.loadingRole = false
              }
            } else {
              this.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur')
              this.loadingRole = false
            }
          },
          response => {
            this.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur')
            this.loadingRole = false
          })
        } else {
          this.$message.error('Veuillez renseigner les champs obligatoires')
          this.$notify.error({
            title: "ERREUR D'ENREGISTREMENT",
            message: "Le rôle n'a pas été enregistré.",
            position: 'top-center'
          })
          this.loadingService = false
        }
      },
      retour () {
        this.etatParam = true
        this.etatGlobal = false
        this.etatCode = false
        this.etatAlert = false
        this.etatService = false
        this.etatRoute = false
      },
      imprimeListeServ (type) {
        let url = ""
        if(type == "PDF"){
            url = this.domaine+"webService/imprimerPDF/service/liste"
        }else {
            url = this.domaine+"webService/imprimerEXC/service/liste"
        }
        window.open(url)
      },


      clear () {
        this.$refs.form.reset()
      }
    },
    mounted () {
      this.loadPage()
      this.loadUser()
      this.loadParametre()
      this.loadService()
      // this.loadPrestaire()
      this.loadRoute()
    },
    // beforeMount: function () {
    //   if(!this.roleAcces[this.$router.history.current.name]){
    //     this.$router.push({ name: 'Home'  })
    //   }
    // }
  };
</script>
<style>
    .el-tabs--border-card
    {
        background: #FAFAFA;
    }

    .tooltip-btn {
    position: relative;
    background-color: grey;
    color: white;
  }

  .tooltip-btn::after {
    content: attr(title);
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    padding: 5px;
    border-radius: 5px;
    white-space: nowrap;
    opacity: 0;
    visibility: hidden;
    color: white;
    transition: opacity 0.9s, visibility 0.9s;
  }

  .tooltip-btn:hover::after {
    opacity: 1;
    visibility: visible;
  }
</style>



// WEBPACK FOOTER //
// src/components/Parametre.vue